/* eslint-disable react/button-has-type */
import React from 'react';

import * as styles from './Button.module.scss';

export enum buttonTypes {
    button = 'button',
    submit = 'submit'
}

const buttonVariants = {
    primary: styles.ButtonPrimary,
    secondary: styles.ButtonSecondary,
    white: styles.ButtonWhite
};

const buttonSizes = {
    default: '',
    large: styles.ButtonLarge,
    fullWidth: styles.ButtonFullwidth,
};

interface props {
    type?: buttonTypes,
    title: string,
    onClick?: (...args: any[])=> any,
    variant?: keyof typeof buttonVariants,
    sizes?: keyof typeof buttonSizes,
    primary?: boolean,
    children: React.ReactNode,
    [key: string]: any
}

const Button = ({
    type, title, onClick, variant = 'primary', size = 'default', children, ...rest
}: props): JSX.Element => {
    return (
        <button
            type={type}
            onClick={onClick}
            className={`${styles.Button} ${buttonVariants[variant]} ${buttonSizes[size]}`}
            title={title}
            {...rest}
        >
            {children}
        </button>
    );
};

Button.defaultProps = {
    type: buttonTypes.button,
    onClick: undefined,
};

export default Button;
